import React, { useState, useEffect,useRef } from "react";
import Chart from "react-apexcharts";
import { Switch } from "@mui/material";
import SelectSearch from "react-select-search";
import ConfigService from "../../../services/config-service.js";
import DashboardService from "../../../services/dashboard-service.js";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const MultiColumnBarChart = ({ payInDuration, type, sendStatusSummary, sendStatusSummaryPayout }) => {
  console.log(type);
  console.log(payInDuration);
  const [merchants, setMerchants] = useState([]);
  const [formData, setFormData] = useState({});
  const [statsData, setStatsData] = useState({});
  const [isCount, setIsCount] = useState(false); // Toggle state for Count/Amount
  const selectRef = useRef({});

  const getMerchantsList = (e) => {
    ConfigService.getMerchantDropDown()
      .then((response) => {
        const merchts = response.data.data;
        const arr = [{name:'All Merchants',value:''}];
        for (var i = 0; i < merchts.length; i++) {
          arr.push({
            name: merchts[i].value,
            value: merchts[i].key,
          });
        }
        setMerchants(arr);
      })
      .catch((error) => {
        console.error("Error fetching agents:", error);
      });
  };
  const color1 = "#cbeceff5";
  const color2 = "#495A69";
  const color3 = "#A6BED2A3";
  const color4 = "red";
  const [chartData, setChartData] = useState({
    series: [
      { name: "Revenue", data: [] },
      { name: "Income", data: [] },
      { name: "Growth", data: [] },
      // { name: "Expired", data: [] },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          tools: {
            download: false, // Enables the download button
          },
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%", // Width of each bar
        },
      },
      dataLabels: {
        enabled: false,
      },

      xaxis: {
        categories: [], // Placeholder for dates
        title: {
          text: "Dates",
        },
      },
      yaxis: {
        title: {
          text: "Values",
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "center",
      },
      colors: [color2, color1, color3], // Custom colors for bars
    },
  });
  const handleChangeSearchMerchant = (e) => {
    DashboardService.getPayInAndPayoutStats(e)
      .then((response) => {

        setStatsData(response.data);
        createDataForGraph(response.data, isCount);
      })
      .catch((error) => {
        console.error("Error fetching agents:", error);
      });
  };
  useEffect(() => {
    handleChangeSearchMerchant("")
    getMerchantsList();
  }, []);

  useEffect(() => {
    if (statsData && statsData.data) {
      createDataForGraph(statsData, isCount);
    }
  }, [payInDuration]);
  const createDataForGraph = (data, isCount) => {
    const response =
      type == "PayIn" ? data?.data?.payin?.data : data?.data?.payout?.data;
    const dates = [];
    const revenueData = [];
    const incomeData = [];
    const growthData = [];
    const expiredData = []
    if (payInDuration === "Today") {
      dates.push(response[0].date);
      let pendingStatus = response[0].statuses.find(
        (item) => item.status === "AA"
      );
      let completedStatus = response[0].statuses.find(
        (item) => item.status === "A"
      );
      let intitatedStaus = response[0].statuses.find(
        (item) => item.status === "I"
      );
      let expiredStatus = response[0].statuses.find(
        (item) => item.status === "E"
      );
      if (isCount === false) {
        revenueData.push(
          Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0)
        );
        incomeData.push(
          Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0)
        );
        growthData.push(
          Number(intitatedStaus ? intitatedStaus.total_count.toFixed(2) : 0)
        );
        expiredData.push(
          Number(expiredStatus ? expiredStatus.total_count.toFixed(2) : 0)
        );
      } else {
        revenueData.push(
          Number(pendingStatus ? pendingStatus.total_amount.toFixed(2) : 0)
        );
        incomeData.push(
          Number(completedStatus ? completedStatus.total_amount.toFixed(2) : 0)
        );
        growthData.push(
          Number(intitatedStaus ? intitatedStaus.total_amount.toFixed(2) : 0)
        );
        expiredData.push(
          Number(expiredStatus ? expiredStatus.total_amount.toFixed(2) : 0)
        );
      }
    }
    if (payInDuration === "Yesterday") {
      dates.push(response[1].date);
      let pendingStatus = response[1].statuses.find(
        (item) => item.status === "AA"
      );
      let completedStatus = response[1].statuses.find(
        (item) => item.status === "A"
      );
      let intitatedStaus = response[1].statuses.find(
        (item) => item.status === "I"
      );
      let expiredStatus = response[1].statuses.find(
        (item) => item.status === "E"
      );
      if (isCount === false) {
        revenueData.push(
          Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0)
        );
        incomeData.push(
          Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0)
        );
        growthData.push(
          Number(intitatedStaus ? intitatedStaus.total_count.toFixed(2) : 0)
        );
        expiredData.push(
          Number(expiredStatus ? expiredStatus.total_count.toFixed(2) : 0)
        );
      } else {
        revenueData.push(
          Number(pendingStatus ? pendingStatus.total_amount.toFixed(2) : 0)
        );
        incomeData.push(
          Number(completedStatus ? completedStatus.total_amount.toFixed(2) : 0)
        );
        growthData.push(
          Number(intitatedStaus ? intitatedStaus.total_amount.toFixed(2) : 0)
        );
        expiredData.push(
          Number(expiredStatus ? expiredStatus.total_amount.toFixed(2) : 0)
        );
      }
    }
    if (payInDuration === "Monthly") {
      for (let i = 0; i < response.length; i++) {
        let pendingStatus = response[i].statuses.find(
          (item) => item.status === "AA"
        );
        let completedStatus = response[i].statuses.find(
          (item) => item.status === "A"
        );
        let intitatedStaus = response[i].statuses.find(
          (item) => item.status === "I"
        );
        let expiredStatus =  response[i].statuses.find(
          (item) => item.status === "E"
        );

        if (isCount === false) {
          revenueData.push(
            Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0)
          );
          incomeData.push(
            Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0)
          );
          growthData.push(
            Number(intitatedStaus ? intitatedStaus.total_count.toFixed(2) : 0)
          );
          expiredData.push(
            Number(expiredStatus ? expiredStatus.total_count.toFixed(2) : 0)
          );
        } else {
          revenueData.push(
            Number(pendingStatus ? pendingStatus.total_amount.toFixed(2) : 0)
          );
          incomeData.push(
            Number(
              completedStatus ? completedStatus.total_amount.toFixed(2) : 0
            )
          );
          growthData.push(
            Number(intitatedStaus ? intitatedStaus.total_amount.toFixed(2) : 0)
          );
          expiredData.push(
            Number(expiredStatus ? expiredStatus.total_amount.toFixed(2) : 0)
          );
        }
        dates.push(response[i].date);
      }
    }
    if (payInDuration === "Weekly") {
      const today = response[0].date; // Get the 'today' date from the backend (e.g., "2025-01-27")
      
      // Convert the 'today' date to a Date object
      const todayDate = new Date(today);
    
      // Loop through the data and filter for the last 7 days
      for (let i = 0; i < response.length; i++) {
        const item = response[i];
        const itemDate = new Date(item.date); // Convert the item date to a Date object
        const diffTime = todayDate - itemDate; // Get the difference in time between today and the item date
        const diffDays = diffTime / (1000 * 3600 * 24); // Convert the difference from milliseconds to days
    
        // Only process data if the date is within the last 7 days
        if (diffDays >= 0 && diffDays <= 7) {
          dates.push(item.date); // Push the date to the dates array
    
          let pendingStatus = item.statuses.find((status) => status.status === "AA");
          let completedStatus = item.statuses.find((status) => status.status === "A");
          let initiatedStatus = item.statuses.find((status) => status.status === "I");
          let expiredStatus = item.statuses.find((status) => status.status === "E");
    
          if (isCount === false) {
            revenueData.push(
              Number(pendingStatus ? pendingStatus.total_count.toFixed(2) : 0)
            );
            incomeData.push(
              Number(completedStatus ? completedStatus.total_count.toFixed(2) : 0)
            );
            growthData.push(
              Number(initiatedStatus ? initiatedStatus.total_count.toFixed(2) : 0)
            );
            expiredData.push(
              Number(expiredStatus ? expiredStatus.total_count.toFixed(2) : 0)
            );
          } else {
            revenueData.push(
              Number(pendingStatus ? pendingStatus.total_amount.toFixed(2) : 0)
            );
            incomeData.push(
              Number(completedStatus ? completedStatus.total_amount.toFixed(2) : 0)
            );
            growthData.push(
              Number(initiatedStatus ? initiatedStatus.total_amount.toFixed(2) : 0)
            );
            expiredData.push(
              Number(expiredStatus ? expiredStatus.total_amount.toFixed(2) : 0)
            );
          }
        }
      }
    }
    

    // Generate random data for demonstration
    // revenueData.push(Number(response[i].total_amount)); // Revenue (500-1500)
    //incomeData.push(Math.floor(Math.random() * 500) + 200); // Income (200-700)
    //growthData.push(Math.floor(Math.random() * 600) + 5); // Growth (5-25)

    console.log(response);

    // Update the chart with generated data
    setChartData((prevData) => ({
      ...prevData,
      series: [
        { name: "Pending", data: revenueData },
        { name: "Completed", data: incomeData },
        { name: "Initiated", data: growthData },
        // { name: "Expired", data: expiredData },
      ],
      options: { ...prevData.options, xaxis: { categories: dates } },
    }));
   const statusSummary =  getStatusSummary(data,payInDuration,isCount)
if(type === 'PayIn') {
  sendStatusSummary(statusSummary);

} else {
  sendStatusSummaryPayout(statusSummary);

}

  };
  const handleIconClick = (name) => {
    if (selectRef.current) {
      if (selectRef.current[name]) {
        selectRef.current[name].focus(); // Focus on the specific dropdown input
      }
    }
  };
  const toggleSwitch = (e) => {
    const value = e.target.checked;
    console.log(statsData);
    setIsCount(value);
    if(Object.entries(statsData).length !==0 ) {
      createDataForGraph(statsData, value);

    }
  };
  const setSelectRef = (name, select) => {
    if (select) {
      if (selectRef.current) {
        selectRef.current[name] = select.querySelector("input");
      }
    }
  };

  const getStatusSummary = (data, period, isCount) => {
    console.log(isCount)
    const payinData = data.data.payin.data;
    const payoutData = data.data.payout.data;
  
    let filteredPayin = [];
    let filteredPayout = [];
  
    // Filter based on the period
    if (period === "Today") {
      filteredPayin = payinData.slice(0, 1);
      filteredPayout = payoutData.slice(0, 1);
    } else if (period === "Yesterday") {
      filteredPayin = payinData.slice(1, 2);
      filteredPayout = payoutData.slice(1, 2);
    } else if (period === "Weekly") {
      filteredPayin = payinData.slice(0, -7);
      filteredPayout = payoutData.slice(0, -7);
    } else {
      filteredPayin = payinData;
      filteredPayout = payoutData;
    }
  
    const statusList = ["O", "A", "I", "AA", "F", "E"]; // List of all six statuses
    const statusNames = {
      O: "Orders",
      A: "Completed",
      I: "Initiated",
      AA: "Pending",
      F:  "Failed",
      E: "Expired"
    };
  
    const aggregateStatus = (dataArray,isCount) => {
      console.log(isCount)
      const statusMap = {};
      let totalAmount = 0;
      let totalOrders = 0; // Track total orders separately

      // Initialize statusMap with 0 for all statuses
      statusList.forEach(status => {
        statusMap[status] = 0; // Ensure each status starts with 0
      });
  
      dataArray.forEach(({ statuses }) => {
        statuses.forEach(({ status, total_amount,total_count }) => {
          if (statusMap[status] !== undefined) {
            statusMap[status] += isCount ? total_amount : total_count; // Add amount to corresponding status
            totalAmount += isCount ? total_amount : total_count; // Add to the total amount
            totalOrders += isCount ? total_amount : total_count; // Sum all amounts for "Orders"

          }
        });
      });
  
      const result = [];
      statusList.forEach(status => {
        const count = status === "O" ? totalOrders : statusMap[status];
        const percentage = totalAmount > 0 ? ((count / totalAmount) * 100).toFixed(0) : "0";
        result.push({
          status: statusNames[status],
          count: count.toFixed(0), // Format count to 2 decimal places
          percentage: `${percentage}%` // Append percentage symbol
        });
      });
  
      
      return result;
    };
  
    return {
      payin: aggregateStatus(filteredPayin,isCount),
      payout: aggregateStatus(filteredPayout,isCount),
    };
  };

  return (
    <div>
      <div className="d-flex flex-column flex-md-row align-items-center justify-content-between mb-4">
        <div>
        <label
          className="mb-0 text-color-theme"
          style={{ fontSize: "15px", fontWeight: "bolder" }}
        >
          Count
        </label>
        <Switch checked={isCount} onChange={toggleSwitch} />
        <label
          className="mb-0 text-color-theme"
          style={{ fontSize: "15px", fontWeight: "bolder" }}
        >
          Amount
        </label>
        </div>
       
        <div
          className="pay-in position-relative"
          style={{ paddingLeft: "" }}
        >
          <SelectSearch
            search={true}
            options={merchants}
            onChange={handleChangeSearchMerchant}
            ref={(select) =>
              setSelectRef("customer_id", select)
            }
            value={formData.customer_id}
            name="customer_id"
            placeholder="All Merchants"
          />
          <span
            className="position-absolute"
            style={{ bottom: "4px", zIndex: "999", right: "9px", cursor: "pointer" }}
            onClick={() => handleIconClick("customer_id")}

          >
            <KeyboardArrowDownIcon />
          </span>
        </div>
      </div>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default MultiColumnBarChart;
